import React from "react";

import { IgTextField, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import type { ConfigurationInputProps } from "../../../../../types/organization";
import { toProperCaseWithSpaces } from "../../../../../utils";

export const StringOrNumberInput = ({
  config,
  onChange,
}: ConfigurationInputProps) => {
  return (
    <Grid
      item
      container
      direction={"row"}
      alignItems={"center"}
      columnSpacing={2}
    >
      <Grid item sx={{ minWidth: "250px" }}>
        <IgTypography>{toProperCaseWithSpaces(config.key)}:</IgTypography>
      </Grid>
      <Grid item>
        <IgTextField
          value={config.value || ""}
          onChange={(e: any) => onChange(e.target.value)}
          id="outlined-basic"
          label=""
          variant="outlined"
          size="small"
        />
      </Grid>
    </Grid>
  );
};
